let inject = ['$q','$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];
class PqrsListService {
  constructor ($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
    this.$q = $q;
    this.$http = $http;
    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
    this.ngAuthSettings = ngAuthSettings;
    this.AuthTokenFactory = AuthTokenFactory;
    this.SharedService = SharedService;
    this.SessionService = SessionService;
  }

  getPQRSList(userId) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri +this.ngAuthSettings.config.paths.PQRS.LIST + '?userId=' + userId,
        cache : false
      }).then(response => {
        resolve(response.data);
      }).catch(reason => {
        reject(reason);
      });
    });
  }
  
  getPQRSParams() {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri +this.ngAuthSettings.config.paths.PQRS.PARAMS,
        cache : false
      }).then(({data}) => {
        if(!data.error) { resolve(data.data.pqrsParams); }
        else { reject(data.data); }
      }).catch(reason => {
        reject(reason.data);
      });
    });
  }

  sendMailPqrsList(data) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.mailPqrsList,
        data: this.$httpParamSerializerJQLike(data),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
  
  savePQRS(userId, data) {
    data.userId = userId;
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.PQRS.SAVE,
        data: this.$httpParamSerializerJQLike(data),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function ({data}) {
        if(!data.error) { resolve(data.data.pqrsId); }
        else { reject(data.data); }
      }, function (reason) {
        reject(reason);
      });
    });
  }


}

PqrsListService.$inject = inject;

export default PqrsListService;



// WEBPACK FOOTER //
// ./www/components/pqrs/pqrs-list/pqrs-list.service.js